import { gql } from "@apollo/client";

export const GET_REFERRAL_BY_EMAIL = gql`
  mutation getReferralByEmail($email: String!) {
    getReferralByEmail(email: $email) {
      url
      referralCode
      messages
      success
    }
  }
`;

export const SEND_INVITE_VIA_MAIL = gql`
  mutation sendInviteViaEmail($email: String!,$friendsEmail: [String!]!) {
    sendInviteViaEmail(email: $email,friendsEmail: $friendsEmail) {
      messages
      success
    }
  }
`;
